export interface ICategoryItem {
    /** 服务类别ID */
    categoryID: number;
    /** 服务类别名称 */
    categoryName: string;
    /** 服务列表 */
    serviceList: IServiceItem[];
}

export interface ICityItem {
    /** 城市ID */
    cityID: number;
    /** 城市名称 */
    cityName: string;
}

export interface ISubCategoryItem {
    /** 二级分类ID */
    categoryID: number;
    /** 二级分类名称 */
    categoryName: string;
}

export interface IServiceItem {
    /** 服务商ID */
    serviceProviderID: number;
    /** 服务商名称 */
    serviceProviderName: string;
    /** 审核ID */
    serviceAuditID: number;
    /** 服务ID */
    serviceID: number;
    /** 服务名称 */
    serviceName: string;
    /** 0:美团页面  1:第三方页面,默认0 */
    refType: RefTypeEnum;
    /** 要跳转第三方页面URL。仅在refType为1的时有效 */
    refURL: string;
    /** logo图片地址URL */
    logo: string;
    /** 标签 */
    tags: string[];
    /** 城市列表 */
    cities: ICityItem[];
    /** 服务状态  1 正常 0 不展示 (在app和pc) */
    serviceStatus: ServiceStatusEnum;
    /** 上架状态  1:上架  0:未上架  */
    onlineStatus: OnlineStatusEnum;
    /** 审核状态：0待审核 1已通过 2未通过 */
    approvedStatus: ApprovedStatusEnum;
    /** 审核意见  */
    opinion: string;
    /** 处罚状态 1:正常 2:置休 3:永久下架 */
    punishStatus: PunishStatusEnum;
    /** 冻结天数 只有punishStatus为:2置休的时候,此参数生效,其他状态此参数值为:0 */
    pauseDay: number;
    /** 恢复时间,如2018-10-10 23:59 */
    releaseTime: string;
    /** 二级分类信息 */
    subCategory: ISubCategoryItem;
    /** 是否为新品 */
    isNewItem: 0 | 1;
    /** 新品推广期保护时间 */
    newItemPassTime: number;
    /** 是否有生效活动 */
    actStatus: OnlineActEnum;
    /** 自有商品标记：1 自有商品；0 其它服务商的商品，不支持编辑 */
    ownFlag: OwnFlagEnum;
}

export enum OwnFlagEnum {
    /** 自有商品 */
    own = 1,
    /** 其它服务商的商品 */
    other = 0,
}

export enum RefTypeEnum {
    /** 美团页面 */
    inner = 0,
    /** 第三方页面 */
    outer = 1,
}

export enum ServiceStatusEnum {
    /** 不展示 */
    unShow = 0,
    /** 展示 */
    show = 1,
}

export enum OnlineStatusEnum {
    /** 下架 */
    offline = 0,
    /** 上架 */
    online = 1,
}

export enum ApprovedStatusEnum {
    /** 审核中 */
    wait = 0,
    /** 已通过 */
    passed = 1,
    /** 未通过 */
    notPass = 2,
}

/**
 * 审核状态，对应列表中的资料状态
 */
export enum ApprovedStatusZH {
    '审核中' = 0,
    '已通过' = 1,
    '未通过' = 2,
}

export enum PunishStatusEnum {
    /** 正常 */
    normal = 1,
    /** 冻结 */
    rest = 2,
    /** 永久下架 */
    dropOff = 3,
}

/**
 * 处罚状态
 */
export enum PunishStatusZH {
    '正常' = 1,
    '冻结' = 2,
    '永久下架' = 3,
}

/**
 * 是否有生效活动
 */
export enum OnlineActEnum {
    /** 有生效或待生效活动 */
    hasAct = 1,
    /** 没有 */
    noAct = 0,
}

export interface IListProps {
    list: IServiceItem[];
    refresh: Function;
    tableLoading: boolean;
}

export interface IInfoProps {
    service: IServiceItem;
}

export interface IModalProps {
    service: IServiceItem | undefined;
    handleClose: Function;
    visible: boolean;
    refresh: Function;
}

export interface IOnlineServiceReq {
    serviceID: number;
    onlineStatus: OnlineStatusEnum;
}

export interface IDelServiceReq {
    serviceID: number;
    serviceAuditID: number;
}

export interface ICopyButtonProps {
    /** 商品id */
    id: number;
    /** 商品名称 */
    name: string;
    /** 自有商品标记  */
    ownFlag: OwnFlagEnum;
}

export interface IQrcodeButtonProps {
    /** 商品id */
    id: number;
}
